export default "__VITE_ASSET__jJRhO_2Q__"